<template>
<div>
  <floating-menu :event-id="eventId"></floating-menu>

  <b-card>
    <b-row>
      <b-col cols="4">
        <p>
          <b>Registration Link:</b><br>
          <a :href="'' + this.eventData.url  + ''" target="_blank">{{ this.eventData.url }}</a>
          <qrcode-vue style="margin-top:20px" size="300" :value="this.eventData.url"></qrcode-vue>
        </p>
      </b-col>
      <b-col cols="4">
        <p>
          <b>Feedback Form Link:</b><br>
          <a :href="'' + this.eventData.feedback_url + ''" target="_blank" v-if="this.eventData.feedback_url.length > 0">{{ this.eventData.feedback_url }}</a>
          <qrcode-vue style="margin-top:20px;" size="300" v-if="this.eventData.feedback_url.length > 0" :value="this.eventData.feedback_url"></qrcode-vue>
          <div v-if="this.eventData.feedback_url.length == 0">-</div>
        </p>
      </b-col>
      <b-col cols="4">
        <p>
          <b>Passport Link:</b><br>
          <a :href="'' + this.eventData.passport_url  + ''" target="_blank">{{ this.eventData.passport_url }}</a>
          <qrcode-vue style="margin-top:20px" size="300" :value="this.eventData.passport_url"></qrcode-vue>
        </p>
      </b-col>
    </b-row>
  </b-card>

  <b-card>
    <b-row>
      <b-col cols="12">
        <div v-if="!(eventData && eventCategories && eventTypes)" class="text-center">
          <b-spinner label="Loading..."></b-spinner>
        </div>
        <event-edit-content :is-view=true :event-data="eventData" :field-groups="fieldGroups" :event-categories="eventCategories" :event-types="eventTypes" :companies="companies" v-if="eventData && eventCategories && eventTypes && companies && fieldGroups" />
      </b-col>
    </b-row>
  </b-card>
</div>
</template>

<script>
import { BRow, BCol, BCard, BSpinner } from 'bootstrap-vue'
import EventEditContent from './EventEditContent.vue'
import router from '@/router'
import moment from 'moment'
import FloatingMenu from './FloatingMenu.vue'
import QrcodeVue from 'qrcode.vue'


export default {
  components: {
    BRow,
    BCol,
    BCard,
    BSpinner,
    FloatingMenu,
    EventEditContent,
    QrcodeVue
  },

  data() {
    return {
      eventId: router.currentRoute.params.id,
      eventData: {
        url:"-",
        feedback_url:""
      },
      eventCategories: null,
      eventTypes: null,
      companies: null,
      fieldGroups: null
    }
  },

  methods: {
    formatDateReverse(value) {
      return moment(String(value), 'YYYY-MM-DD').format('DD-MM-YYYY')
    },
    fetchFieldGroups() {
      this.$http.get('/admin/v1/field_groups')
        .then(res => {
          const data = res.data
          const message = data.message

          if(!data.status) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: `Error`,
                icon: 'CoffeeIcon',
                variant: 'danger',
                text: message,
              },
            })
          }
          else {
            const currentData = res.data.data

            this.fieldGroups = []

            currentData.forEach((item, index) => {
              this.fieldGroups.push({
                name: item.name,
                fields: item.fields
              })
            }) 
          }
       })
    },
    fetchEventCategories() {
      this.$http.get('/admin/v1/event_categories')
        .then(res => {
          const data = res.data
          const message = data.message

          if(!data.status) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: `Error`,
                icon: 'CoffeeIcon',
                variant: 'danger',
                text: message,
              },
            })
          }
          else {
            const currentData = res.data.data

            this.eventCategories = []

            currentData.forEach((item, index) => {
              this.eventCategories.push({
                label: item.category,
                value: item.id
              })
            })
            
          }
      })
    },
    fetchCompanies() {
      this.$http.get('/admin/v1/companies')
        .then(res => {
          const data = res.data
          const message = data.message

          if(!data.status) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: `Error`,
                icon: 'CoffeeIcon',
                variant: 'danger',
                text: message,
              },
            })
          }
          else {
            const currentData = res.data.data

            this.companies = []

            currentData.forEach((item, index) => {
              this.companies.push({
                label: item.name,
                value: item.id
              })
            })
            
          }
      })
    },
    fetchEventTypes() {
      this.$http.get('/admin/v1/event_types')
        .then(res => {
          const data = res.data
          const message = data.message

          if(!data.status) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: `Error`,
                icon: 'CoffeeIcon',
                variant: 'danger',
                text: message,
              },
            })
          }
          else {
            const currentData = res.data.data

            this.eventTypes = []

            currentData.forEach((item, index) => {
              this.eventTypes.push({
                label: item.type,
                value: item.id
              })
            })
            
          }
      })
    },

    fetchEventData() {
      const id = router.currentRoute.params.id

      this.$http.get('/admin/v1/events/' + id)
        .then(res => {
          const data = res.data
          const message = data.message

          if(!data.status) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: `Error`,
                icon: 'CoffeeIcon',
                variant: 'danger',
                text: message,
              },
            })
          }
          else {
            const currentData = res.data.data
            this.eventData = {
              id: currentData.id,
              url: currentData.url,
              feedback_url: currentData.feedback_url,
              passport_url: currentData.feedback_url.replace('/feedback/', '/passport/'),
              name: currentData.name,
              banner_url: currentData.banner_url,
              nametag_url: currentData.nametag_url,
              nametag_blob: null,
              banner_blob: null,
              logo_blob: null,
              logo_url: currentData.logo_url,
              file_blob: null,
              file_url: currentData.file_url,
              date_start: currentData.date_start,
              date_end: currentData.date_end,
              start_registration_date: currentData.start_registration_date,
              end_registration_date: currentData.end_registration_date,
              description: currentData.description,
              location: currentData.location,
              event_type_id: currentData.event_type_id,
              event_category_id: currentData.event_category_id,
              facebook_link: currentData.facebook_link,
              instagram_link: currentData.instagram_link,
              linkedin_link: currentData.linkedin_link,
              web_link: currentData.web_link,
              success_register_message: currentData.success_register_message,
              success_feedback_message: currentData.feedback_success_response,
              price: currentData.price,
              company_id: currentData.company_id,
              itineraries: currentData.itineraries,
              sliders: currentData.sliders,
              sliders_blob: null,
              date: null,
              registration_date: null,
              company: currentData.company,
              type: currentData.type,
              category: currentData.category,
              fields: currentData.fields,
              use_payment_gateway: (currentData.use_payment_gateway == 1),
              register_auto_approved: (currentData.register_auto_approved == 1),
              using_email: (currentData.using_email == 1),
              has_gift: (currentData.has_gift == 1),
              only_office_email: (currentData.is_only_office_email == 1),
              restricted_email_domains: currentData.disallowed_email_domains,
              whatsapp_message: currentData.whatsapp_message,
              has_agree_tnc: (currentData.has_agree_tnc == 1),
              tnc_notes: currentData.tnc_notes,

              info_under_submit: currentData.info_under_submit,
              use_bold_on_info: currentData.use_bold_on_info == 1?'True' : 'False',
              close_registration: currentData.close_registration == 1?'True' : 'False',
              date_display: currentData.date_display,
              payment_info: currentData.payment_info,

              font_style: currentData.font_style,
              font_color: currentData.font_color,
              font_size: currentData.font_size,
              company_first: currentData.company_first,
              font_blob: null,
              font_url: currentData.font_url
            }
          }
      })
    }
  },
  created() {
    this.fetchEventData()
    this.fetchCompanies()
    this.fetchEventCategories()
    this.fetchEventTypes()
    this.fetchFieldGroups()
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';

.event-table .vgt-responsive {
  min-height: 350px;
}
</style>